import React from 'react';

import RestrictionsServiceTypes from './Fields/RestrictionsServiceTypes';
/* import ExcludedDrivers from './Fields/ExcludedDrivers'; // todo next release */
/* import ExcludedCustomers from './Fields/ExcludedCustomers'; // this functionality will not be */
/* import ExcludedCarriers from './Fields/ExcludedCarriers'; // todo next release */

const Section7 = ({ disabled, form }) => {
  return (
    <div className="sevenSection">
      <div className="border-emmit"></div>
      <div className="aHeight-3"></div>
      <div className="treeColWrap">
        <RestrictionsServiceTypes form={form} disabled={disabled} />
        {/* todo next release <ExcludedCarriers form={form} disabled={disabled} /> */}
        {/* todo next release <ExcludedDrivers form={form} disabled={disabled} /> */}
        {/* todo this functionality will not be <ExcludedCustomers form={form} disabled={disabled} /> */}
      </div>
    </div>
  );
};

export default Section7;
